import { render, staticRenderFns } from "./LifeskillSelectionQuiz.vue?vue&type=template&id=8da6fde2&scoped=true&"
import script from "./LifeskillSelectionQuiz.vue?vue&type=script&lang=js&"
export * from "./LifeskillSelectionQuiz.vue?vue&type=script&lang=js&"
import style0 from "./LifeskillSelectionQuiz.vue?vue&type=style&index=0&id=8da6fde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da6fde2",
  null
  
)

/* custom blocks */
import block0 from "./LifeskillSelectionQuiz.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports